<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :onConfigReady="onQueryConfigReady" :queryOnLoad="queryOnLoad" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'

    import { SysParamCodes } from '../../app.const'

    import { getDefaultPageSizes } from '../../../src/app.conf'
    import { openShopDeviceImpItemListDlg, openShopDeviceImpCheckDlg, shopDeviceFormatExplDlg } from './selectDlg'
    import { getMerchantBizParam } from '../asset/assetMain'
    import { fileUploadGroupShowDlg } from '../comn/dialog'
    import { getIncludeSubComsByMetaQueryConf } from '../conf/ComnConfStorer'

    import comnApi from '../../api/comn'
    import devcApi from '../../api/devc'
    import contractApi from '../../api/contract'
    import userApi from '../../api/user'
    import merchtComnApi from '../../api/merchtComn'
    import shopStockApi from '../../api/shopStock'
    //
    import SwbPopoverOrgTree from '../orgStruct/PopoverOrgTree';
    Vue.regist(SwbPopoverOrgTree);

    import SwbFileItem from '../ctrl/FileItem';
    Vue.regist(SwbFileItem);
    import SwbFileUpload from '../ctrl/FileUpload';
    Vue.regist(SwbFileUpload);
    import SwbOrgTree from '../orgStruct/OrgTree';
    Vue.regist(SwbOrgTree);

    import SwbShopDeviceAssetList from './ShopDeviceAssetList.vue'
    Routes.add(SwbShopDeviceAssetList);

    import SwbShopDeviceImpAsserCheck from './ShopDevcImpAssetCheck.vue'

    import { checkUserActionPerm } from '../index';
    Vue.regist(SwbShopDeviceImpAsserCheck);

    export default {
        name: 'swb-shop-devc-imp-rec-asset-update-list',
        desc: '机构资产导入记录列表',
        data: function () {
            return {
                confKey: 'swb-shop-devc-imp-rec-asset-update-list',
                tableHeight: 300,
                queryOnLoad: true,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 240,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                includeSubComs: false,
                initIncludeSubComs: false,
                //
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                shopDeviceImpRecList: [],
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                file: {},
                theLoader: null,
                devcVoucherTypeEnumMap: getEnumMap("devcVoucherType", "value2text"),
                mgmtSmlAreaId: null,
                devcCustFieldList: [],
                checkStateMap: getEnumMap("checkState", "value2text"),
                execStateMap: getEnumMap("execState", "value2text"),
            }
        },
        created: function () {
            let self = this;
            this.pageSize = this.pageSizes.first();
            //
            this.getDevcCustFieldList();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass("overflow-hidden");
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;
            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('.breadcrumb-layout, .org-tree-layout, .simple-row, [name="query-sort-block"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            getDevcCustFieldList(){
                let self = this;
                let theLoading = MsgBox.loading();
                merchtComnApi.getDevcCustFieldList({}, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        let devcCustFieldList = result.data;
                        self.devcCustFieldList = devcCustFieldList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            onQueryConfigReady: function () {
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let devcVoucherTypeList = getEnumList('devcVoucherType');
                let dataList = [];
                devcVoucherTypeList.forEach(function (devcVoucherType) {
                    dataList.push({
                        value: devcVoucherType.value,
                        label: devcVoucherType.text
                    });
                });
                //
                let fieldInfo = {};
                fieldInfo["srcVoucherType"] = {dataList: dataList};
                query_model_ctrl.updateFields(fieldInfo);
            },
            initResultTable(){
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                // let confColList = resultColConfCmp.getMetaColList();
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);// .getResultColConfRef()
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'statusLabel': function (row, colName, colValue, rowIndex, colConf) {
                        let noCountent = '';
                        if(row.virtualFlag) {
                            noCountent = '<a class="swb-tags swb-tags-outlined">补录</a>';
                        }
                        return '<span>' + noCountent + '</span>';
                    },
                    'srcVoucherType': function (row, colName, colValue, rowIndex, colConf) {
                        let srcVoucherType = self.devcVoucherTypeEnumMap[row.srcVoucherType] || "";
                        //
                        return '<span>' + srcVoucherType + '</span>';
                    },
                    'totalCount': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.normalDeviceCount != null && row.durableDeviceCount != null) {
                            let totalCount = row.normalDeviceCount + row.durableDeviceCount;
                            //
                            return '<span>' + totalCount + '</span>';
                        }
                    },
                    'checkState': function (row, colName, colValue, rowIndex, colConf) {
                        return '<span>' + self.checkStateMap[row.checkState] + '</span>';
                    },
                    'execState': function (row, colName, colValue, rowIndex, colConf) {
                        return '<span>' + self.execStateMap[row.execState] + '</span>';
                    },
                    'fiscalState': function (row, colName, colValue, rowIndex, colConf) {
                        return '<span>' + self.execStateMap[row.fiscalState] + '</span>';
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let btnList = [];
                        // 过程中不可操作
                        if(row.checkState != 2 && row.execState != 2 && row.fiscalState != 2) {
                            if(self.checkActionPerm("check", row.shopId) && row.checkState != 1) {
                                btnList.push({
                                    name: 'check',
                                    text: '核对'
                                });
                            }
                            if(self.checkActionPerm("done", row.shopId) && row.checkState == 1 && row.execState != 1) {
                                btnList.push({
                                    name: 'done',
                                    text: '执行'
                                });
                            }
                            if(self.checkActionPerm("update", row.shopId) && row.execState != 1) {
                                btnList.push({
                                    name: 'update',
                                    text: '编辑'
                                });
                            }
                            if(self.checkActionPerm("delete", row.shopId) && row.execState == 0) {
                                btnList.push({
                                    name: 'delete',
                                    text: '删除'
                                });
                            }
                        } else if(self.checkActionPerm("stop", row.shopId)) {
                            btnList.push({
                                name: 'stop',
                                text: '停止'
                            });
                        }
                        if(self.checkActionPerm("showImpItem", row.shopId)){
                            btnList.push({
                                name: 'showImpItem',
                                text: '查看明细'
                            });
                        }
                        return btnList;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
//                    'imageUrl': function (row, colName, colValue, rowIndex, btnName) {
//                        self.viewImage(colValue);
//                    },
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if(!Utils.repeatChecker.isValidFor(btnName, 1000)) {
                            return;
                        }
                        // 单品式管理
                        if(btnName == 'showImpItem') {
                            self.showImpItem(row.id);
                        } else if(btnName == 'gotoShopDeviceSvcSubNo') {
                            self.gotoShopDeviceSvcSubNo(row);
                        } else if(btnName == 'toSaveDeviceAppturn') {
                            self.toSaveDeviceAppturn(row);
                        } else if(btnName == 'check') {
                            self.doCheck(row.id);
                        } else if(btnName == 'done') {
                            self.doDone(row);
                        } else if(btnName == 'update') {
                            self.doUpdate(row.id);
                        } else if(btnName == 'delete') {
                            self.deleteRec(row.id);
                        } else if(btnName == 'inFiscal') {
                            self.doImpRecInFiscal([row.id]);
                        } else if(btnName == 'stop') {
                            self.doStopImpRec(row.id);
                        }
                    }
                });
            },
            checkActionPerm: function (action, dataOwnerComId) {
                // 故意注释掉的，不需要action控制
                return true; // checkUserActionPerm(Vue.$getClassInfo(this).path, action, null, dataOwnerComId);
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            //
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getShopDeviceImpRecList();
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getShopDeviceImpRecList();
            },
            showImpItem: function (recId) {
                //
                openShopDeviceImpItemListDlg({recId: recId}, this);
            },
            showFormatElpx: function () {
                shopDeviceFormatExplDlg();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getShopDeviceImpRecList();
            },
            getShopDeviceImpRecList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.assetType = -1;
                filterItems.deviceFlag = false;
                filterItems.updateFlag = true;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoading = MsgBox.loading();
                devcApi.getShopDeviceImpRecListByFilter(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        let shopDeviceImpRecList = result.data.rows;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        //
                        self.renderTable(shopDeviceImpRecList, pagination);
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            gotoShopDeviceSvcSubNo: function (row) {
                let self = this;
                let comId = null;
                if(row.shopId == this.thisComId) {
                    comId = this.thisComId;
                } else {
                    comId = row.shopId;
                }
                self.$router.push({
                    path: SwbShopDeviceAssetList.path,
                    query: {
                        importNo: row.no,
                        includeSubComs: true,
                        selectComId: comId,
                    }
                });
            },
            // 领用单
            toSaveDeviceAppturn: function (row) {
//                warehouseId: warehouseId,
//                    imported: true,
//                    impNo: impNo,
                let self = this;
                self.$router.push({
                    path: SwbShopDeviceAppturnVoucherItemSave.path,
                    query: {
                        ioFlag: getEnumInfoWith('ioFlag', 'name', 'IoIn').value,
                        shopId: row.shopId,
                        shopBizUnitId: row.shopBizUnitId,
                        warehouseId: row.warehouseId,
                        importNo: row.no,
                        parentPath: '/shop/devc/imp/rec/asset/list',
                    }
                });
            },
            //
            generalImport: function () {
                let self = this;
                let uploadParams = {
                    title: "资产导入",
                    fileFor: "devc.import",
                    fileGroup: "device.import",
                    multipleFile: false,
                    custFileds: JSON.encode(self.devcCustFieldList),
                    assetNatureFlag: true,
                    usage: 'asset.common.import' //
                };
                fileUploadGroupShowDlg(uploadParams, "/api/shop/device/device/imp/model/template/file/download?shopId=" + self.thisComId, function (result, theDlg) {
                    // theDlg 关闭弹框
                    theDlg.close();
                    if(result.type === 'info') {
                        let files = result.data.files;
                        self.file = files[0];
                        // 文件是否按模版导入
                        let errorMsgList = self.file.extra.errorMsgList;
                        if(!Utils.isNoB(errorMsgList) && errorMsgList.length > 0) {
                            MsgBox.warning(errorMsgList.join("<br/>"));
                            return;
                        }
                        self.handleImpInfoStart(self.file.extra, uploadParams.usage);
                    } else {
                        MsgBox.warning(result.message);
                    }
                }, null, function (assetNature, callback) {
                    let usage = '';
                    if(assetNature == 1){
                        usage = 'asset.fixed.import';
                    } else if(assetNature == 2){
                        usage = 'asset.lowvl.import';
                    } else if(assetNature == 3){
                        usage = 'asset.small.import';
                    } else {
                        usage = 'asset.common.import';
                    }
                    uploadParams.usage = usage;
                    callback(usage);
                });
            },
            handleImpInfoStart(extra, usage){
                let deviceImpInfoList = extra.deviceImpInfoList;
                if(deviceImpInfoList == null || deviceImpInfoList.length == 0) {
                    MsgBox.warning('文件中未解析到数据');
                    return;
                }
                let self = this;
                let deviceImpDto = {
                    retailerShopId: self.thisComId,
                    retailerBizUnitId: self.thisBizUnitId,
                    originalFileName: extra.originalFileName,
                    virtualFlag: false,
                    tplUsage: usage
                };
                let postData = {
                    retailerShopId: self.thisComId,
                    retailerBizUnitId: self.thisBizUnitId,
                    originalFileName: extra.originalFileName
                };
                let theLoading = MsgBox.loading("正在检查导入文件");
                devcApi.validateImpFileRepetition(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        if(result.data == true) {
                            for(let i = 0; i < deviceImpInfoList.length; i++) {
                                let deviceImpInfo = deviceImpInfoList[i];
                                deviceImpInfo.recItemId = null;
                            }
                            self.startDone(deviceImpDto, deviceImpInfoList, 1, 1000);
                        } else {
                            self.$message.warning('此机构已导入过这个文件,请勿重复导入');
                        }
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            startDone(srcImpDto, srcImpInfoList, pageNumber, pageSize){
                let self = this;
                let paramImpDto = Utils.merge({}, srcImpDto);
                let totalCount = srcImpInfoList.length;
                let start = (pageNumber - 1) * pageSize;
                let end = pageNumber * pageSize;
                let paramImpInfoList = srcImpInfoList.slice(start, end);
                paramImpDto.deviceImpInfoList = paramImpInfoList;
                paramImpDto.lastFlag = end >= totalCount;
                // end/totalCount
                let theLoading = MsgBox.loading("正在处理【" + (end > totalCount ? totalCount : end) + "/" + totalCount + "】，请稍后...");
                devcApi.saveDeviceImpModel(paramImpDto, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        srcImpDto.importRecId = result.data;
                    } else if(paramImpDto.importRecId == null) {
                        // 第一此都没过去，记录没生成,直接结束
                        MsgBox.warning(result.message);
                        return;
                    }
                    if(end < totalCount) {
                        pageNumber = pageNumber + 1;
                        self.startDone(srcImpDto, srcImpInfoList, pageNumber, pageSize);
                    } else {
                        // 最后一批结束
                        MsgBox.info('文件数据保存成功,请检查通过后执行导入');
                        self.getShopDeviceImpRecList();
                    }
                });
            },
            deleteRec(id){
                let self = this;
                //弹出确认框
                this.$confirm('确定删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let theLoad = MsgBox.loading();
                    devcApi.deleteShopDeviceImpRecById(id, function (result) {
                        theLoad.hide();
                        if(result.type === "info") {
                            MsgBox.success("操作成功");
                            self.getShopDeviceImpRecList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            },
            doCheck(id){
                let self = this;
                let theLoad = MsgBox.loading();
                devcApi.doImpRecCheck(id, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        MsgBox.success("正在核对,请稍后查看核对结果");
                        self.getShopDeviceImpRecList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            doStopImpRec(id){
                let self = this;
                let theLoad = MsgBox.loading();
                devcApi.doStopImpRec({id: id}, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        MsgBox.success("已停止进行任务");
                        self.getShopDeviceImpRecList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            inFiscalBatch(){
                if(!Utils.repeatChecker.isValidFor("inFiscalBatch", 1000)) {
                    return;
                }
                let multipleSelection = this.getTableSelection();
                if(Utils.isNoB(multipleSelection) || multipleSelection.length <= 0) {
                    MsgBox.warning('请选择需要入账的导入记录');
                    return;
                }
                for(let i = 0; i < multipleSelection.length; i++) {
                    let row = multipleSelection[i];
                    if(row.checkState != 2 && row.fiscalState != 2 && row.execState == 1 && row.fiscalState != 1) {
                        // 可以执行
                    } else {
                        MsgBox.warning('【' + row.no + '】不可入账');
                        return;
                    }
                }
                let ids = multipleSelection.pluck('id');
                this.doImpRecInFiscal(ids);
            },
            doImpRecInFiscal(ids){
                let self = this;
                this.$confirm('确定入账吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let theLoad = MsgBox.loading();
                    devcApi.doImpRecInFiscal(ids, function (result) {
                        theLoad.hide();
                        if(result.type === "info") {
                            MsgBox.success("正在入账,请稍后查看核对结果");
                            self.getShopDeviceImpRecList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            },
            doDone(row){
                let self = this;
                this.$confirm('确定执行吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {
                        id: row.id
                    };
                    self.doImpRecDone(postData);
                }).catch(function () {

                });
            },
            doImpRecDone(postData){
                let self = this;
                let theLoad = MsgBox.loading();
                devcApi.doImpRecDone(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        MsgBox.success("正在执行,请稍后查看执行结果");
                        self.getShopDeviceImpRecList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            doUpdate(id){
                let self = this;
                Vue.$showDialog({
                    title: "机构资产导入编辑",
                    width: -100,
                    height: -20,
                    okVisible: false,
                    cancelVisible: false,
                    extVisible: true,
                    showCloseBtn: true,
                    extText: '关闭',
                    template: '<swb-shop-devc-imp-asset-check :recId="recId" ref="swb_shop_devc_imp_check"></swb-shop-devc-imp-asset-check>',
                    data: {
                        recId: id,
                    },
                    extClicked: function () {
                        let refreshFlag = this.$refs.swb_shop_devc_imp_check.getDlgResult();
                        if(Utils.isTrue(refreshFlag)) {
                            self.getShopDeviceImpRecList();
                        }
                    }
                });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/devc/ShopDevcImpRecAssetUpdateList.vue